module.exports = "/_next/static/images/7223b66f871a2687a080544b49b9376a-nuapp@3x.png";